import { AemMode, isAuthor, isEdit, isPreview } from "Helper/aemHelper";

/**
 * returns current aem mode i.e. author, edit or preview
 * @returns {AemMode}
 */
export const getAemMode = (): AemMode => {
  if (!isAuthor()) {
    return AemMode.PUBLISH;
  }

  if (isEdit()) {
    return AemMode.EDIT;
  }

  if (isPreview()) {
    return AemMode.PREVIEW;
  }

  console.warn("[aemHelper]: aem mode can't be determined!");

  return AemMode.UNDETERMINED;
};
